import React from "react";
import { LucideIcon, Inbox, AlertCircle, CheckCircle, Clock } from "lucide-react";

type EmptyStateProps = {
  title: string;
  description: string;
  icon?: "inbox" | "error" | "success" | "pending" | LucideIcon;
  action?: React.ReactNode;
};

const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  icon = "inbox",
  action,
}) => {
  let IconComponent: LucideIcon;

  if (typeof icon === "string") {
    switch (icon) {
      case "error":
        IconComponent = AlertCircle;
        break;
      case "success":
        IconComponent = CheckCircle;
        break;
      case "pending":
        IconComponent = Clock;
        break;
      case "inbox":
      default:
        IconComponent = Inbox;
    }
  } else {
    IconComponent = icon;
  }

  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
      <div className="rounded-full bg-muted p-3 mb-4">
        <IconComponent className="h-6 w-6 text-muted-foreground" />
      </div>
      <h3 className="text-lg font-medium mb-1">{title}</h3>
      <p className="text-sm text-muted-foreground max-w-sm mb-4">{description}</p>
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
};

export default EmptyState; 